import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL || '';
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';
const forceLocal = import.meta.env.VITE_USE_LOCAL_ONLY === 'true';

export const isSupabaseConfigured =
  !forceLocal &&
  Boolean(url) &&
  Boolean(anonKey) &&
  !url.includes('YOUR_PROJECT_REF') &&
  !anonKey.includes('YOUR_SUPABASE');

export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    })
  : null;

export function backendLabel(): string {
  return isSupabaseConfigured ? 'Supabase' : 'localStorage (offline demo)';
}
